import { render, staticRenderFns } from "./BrokersComparison.vue?vue&type=template&id=0eb2d2ef&"
import script from "./BrokersComparison.vue?vue&type=script&lang=ts&"
export * from "./BrokersComparison.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports